'use es6';

import { Record } from 'immutable';
const AdAccountPermissionsRecord = Record({
  canManageEntities: false,
  canCreateAds: false,
  canCreateAudiences: false,
  currentUserHasConnected: false,
  hubSpotUserId: null,
  networkUserId: null
});
export default AdAccountPermissionsRecord;